import { boot } from 'quasar/wrappers'
import VueLazyLoad from 'vue3-lazyload'

export default boot(({ app }) => {
  app.use(VueLazyLoad)
})
